import { useVersionAwareDrilldownPanelData } from 'features/drilldown/data/DrilldownPanelDataContext'
import { useMemo } from 'react'

import { MetricsPanelData } from './MetricsPanel'
import {
  DEFAULT_AVAILABLE_METRIC_CONFIGS,
  DrilldownMetricConfig,
} from './MetricsPanelConfig'

/** All metric configs available to the current panel: defaults plus the
 * user's custom metrics from explorer state. */
export function useAvailableMetricConfigs(): ReadonlyArray<DrilldownMetricConfig> {
  const {
    panelData: { customMetrics },
  } = useVersionAwareDrilldownPanelData<MetricsPanelData>()

  return useMemo(
    () => [...DEFAULT_AVAILABLE_METRIC_CONFIGS, ...customMetrics],
    [customMetrics]
  )
}
